import React from "react"

import { Flex, Typography } from "antd"
import { useNavigate } from "react-router"

import ButtonComponent from "../../../../../Components/Button"
import { RoutesPaths } from "../../../../../constants/user-routes"
import Images from "../../../../../Images"

import "./ConnectStripePlaceholder.less"

const { Text } = Typography

const ConnectStripePlaceholder = () => {
  const navigate = useNavigate()

  return (
    <Flex
      vertical
      align="center"
      justify="center"
      gap={12}
      className="mc-connect-stripe-placeholder"
    >
      <img
        src={Images.stripe_connect_banner}
        alt=""
        width="36px"
        style={{ border: "1px solid #E1E1E2", borderRadius: "10px" }}
      />
      <Text strong>Connect Stripe to access this page</Text>
      <Text type="secondary" style={{ maxWidth: 360 }}>
        This page is only available to users with an active Stripe connection. To view detailed
        payment and dispute information, please connect your Stripe account.
      </Text>
      <ButtonComponent type="primary" onClick={() => navigate(RoutesPaths.configure.processors)}>
        Connect Stripe now
      </ButtonComponent>
    </Flex>
  )
}

export default ConnectStripePlaceholder
